export enum UserRole {
  USER = 'USER',
  ADMIN = 'ADMIN',
  ADMIN_VIEW = 'ADMIN_VIEW',
}

export const DEFAULT_ROLE = UserRole.USER;

export const ADMIN_ONLY_ROUTES = [
  '/agents',
  '/agent-templates',
  '/agent/',
  '/agent-log-page/',
];

// Routes that can be accessed by ADMIN and ADMIN_VIEW
// Keep templates and logs admin-only unless explicitly needed
export const ADMIN_OR_VIEW_ROUTES = ['/agents', '/agent/', '/agent'];

export function isAdminRoute(pathname: string): boolean {
  return ADMIN_ONLY_ROUTES.some((route) => {
    if (route.endsWith('/')) {
      return pathname.startsWith(route);
    }
    return pathname === route;
  });
}

export function isAdminOrViewRoute(pathname: string): boolean {
  return ADMIN_OR_VIEW_ROUTES.some((route) => {
    if (route.endsWith('/')) {
      return pathname.startsWith(route);
    }
    return pathname === route;
  });
}
